import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/Users/lukas/Sites/git/own-packages/react-i18n-kit/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Playground } from "docz";
import { Translator, TextFallback as Text } from "../components";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <Translator heading page="fallback" num="0" mdxType="Translator" />
    <Translator page="fallback" num="0" mdxType="Translator" />
    <Translator page="fallback" num="1" mdxType="Translator" />
    <Translator page="fallback" num="2" mdxType="Translator" />
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`// ./i18n/index.js
const data = {
  de: {
    text: "Hallo Welt!",
  },
  en: {
    text: "Hello World!",
  },
  es: {
    text: "!Hola Mundo!",
  },
};

export { data };
`}</code></pre>
    <Translator page="fallback" num="3" mdxType="Translator" />
    <Translator page="fallback" num="4" mdxType="Translator" />
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import React from "react";
import { withI18n } from "react-i18n-kit";

import { data } from "./i18n";

const Text = props => <div>{props.i18n.text}</div>;

/*
  Never set a language you do not have a translation for.
  We just use it as example, so you can see the fallback in your browser.
*/
const TextI18n = withI18n(Text, data, {
  lang: "zh",
  fallback: "es",
});

export { TextI18n as Text };
`}</code></pre>
    <Translator page="fallback" num="5" mdxType="Translator" />
    <Playground mdxType="Playground">
  <Text mdxType="Text" />
    </Playground>
    <Translator page="fallback" num="6" mdxType="Translator" />
    <Playground mdxType="Playground">
  <Text lang="zh" fallback="de" mdxType="Text" />
    </Playground>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      